export default {
    BASE_URL: 'https://api.clients.remap.ai',
    STRIPE_KEY: 'pk_test_51LSaZrK7340zxZZkCIDPD7cUjjEH0kssavltmolsOiLRkximAdhzvXkVvPDMdIpzd0lAkkzxVUqgLmmqRAcFFRjD007KL8uwnG',
    SENDGRID_API_KEY: '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',
    DEFAULT_EMAIL: 'andrew@5degrees.com.au',
    PRICING_TABLE_ID: 'prctbl_1Lw3jVK7340zxZZkvKdcoYFC',
    PUBLISHABLE_KEY: 'pk_test_51LSaZrK7340zxZZkCIDPD7cUjjEH0kssavltmolsOiLRkximAdhzvXkVvPDMdIpzd0lAkkzxVUqgLmmqRAcFFRjD007KL8uwnG'
}